import React, { useState } from 'react';
import { ArrowLeft, X, Search, MessageCircle, FileText, ThumbsUp, Package, AlertCircle, Mail, MessageSquare, Bell, Sparkles, Receipt, Tag, Plus } from 'lucide-react';
export const ActionSelectionPanel = ({
  onClose,
  onAgentClick
}) => {
  const [isSelectInstructionsModalOpen, setIsSelectInstructionsModalOpen] = useState(false);
  const handleAgentClick = () => {
    setIsSelectInstructionsModalOpen(true);
  };
  const handleCloseSelectInstructions = () => {
    setIsSelectInstructionsModalOpen(false);
  };
  const handleCreateNewInstructions = () => {
    setIsSelectInstructionsModalOpen(false);
    onAgentClick();
  };
  const existingInstructions = [{
    id: 1,
    name: 'Negative Review Response with Coupon',
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-66">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-67" />
        </svg>
  }, {
    id: 2,
    name: 'Feedback Analysis and Summary',
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-68">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-69" />
        </svg>
  }, {
    id: 3,
    name: 'Inventory Restock Management',
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-70">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-71" />
        </svg>
  }, {
    id: 4,
    name: 'Low Rating Review Response Task',
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-72">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-73" />
        </svg>
  }];
  return <div className="w-[400px] border-r border-gray-200 bg-white flex flex-col h-full" data-id="element-74">
      <div className="p-4 border-b border-gray-200 flex items-center justify-between" data-id="element-75">
        <div className="flex items-center" data-id="element-76">
          <button onClick={onClose} className="mr-3 text-gray-500 hover:text-gray-700" data-id="element-77">
            <ArrowLeft className="w-5 h-5" data-id="element-78" />
          </button>
          <h2 className="text-lg font-medium text-gray-800" data-id="element-79">
            Select an action
          </h2>
        </div>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-80">
          <X className="w-5 h-5" data-id="element-81" />
        </button>
      </div>
      <div className="p-4 border-b border-gray-200" data-id="element-82">
        <div className="relative" data-id="element-83">
          <Search className="absolute left-3 top-2.5 text-gray-400 w-4 h-4" data-id="element-84" />
          <input type="text" placeholder="Search for actions" className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded-full text-sm" data-id="element-85" />
        </div>
      </div>
      <div className="overflow-y-auto flex-1 p-4" data-id="element-86">
        <div className="mb-6" data-id="element-87">
          <div className="flex justify-between items-center mb-2" data-id="element-88">
            <h3 className="text-sm text-gray-500" data-id="element-89">Notifications</h3>
          </div>
          <div className="border border-gray-200 rounded-md mb-2 hover:bg-gray-50 cursor-pointer" data-id="element-90">
            <div className="p-3 flex items-center" data-id="element-91">
              <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center mr-3 flex-shrink-0" data-id="element-92">
                <Mail className="w-4 h-4 text-gray-700" data-id="element-93" />
              </div>
              <div data-id="element-94">
                <div className="text-sm font-medium" data-id="element-95">Send an email</div>
              </div>
            </div>
          </div>
          <div className="border border-gray-200 rounded-md mb-2 hover:bg-gray-50 cursor-pointer" data-id="element-96">
            <div className="p-3 flex items-center" data-id="element-97">
              <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center mr-3 flex-shrink-0" data-id="element-98">
                <MessageSquare className="w-4 h-4 text-gray-700" data-id="element-99" />
              </div>
              <div data-id="element-100">
                <div className="text-sm font-medium" data-id="element-101">Send a chat message</div>
              </div>
            </div>
          </div>
          <div className="border border-gray-200 rounded-md mb-2 hover:bg-gray-50 cursor-pointer" data-id="element-102">
            <div className="p-3 flex items-center" data-id="element-103">
              <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center mr-3 flex-shrink-0" data-id="element-104">
                <Bell className="w-4 h-4 text-gray-700" data-id="element-105" />
              </div>
              <div data-id="element-106">
                <div className="text-sm font-medium" data-id="element-107">
                  Send a push notification
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-6" data-id="element-108">
          <div className="flex justify-between items-center mb-2" data-id="element-109">
            <h3 className="text-sm text-gray-500" data-id="element-110">AI actions</h3>
          </div>
          <div className="border border-gray-200 rounded-md mb-2 hover:bg-gray-50 cursor-pointer" data-id="element-111">
            <div className="p-3 flex items-center" data-id="element-112">
              <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center mr-3 flex-shrink-0" data-id="element-113">
                <Sparkles className="w-4 h-4 text-gray-700" data-id="element-114" />
              </div>
              <div className="flex-1" data-id="element-115">
                <div className="text-sm font-medium" data-id="element-116">Perform LLM call</div>
              </div>
              <span className="text-xs px-2 py-1 bg-gray-700 text-white rounded" data-id="element-117">
                Beta
              </span>
            </div>
          </div>
          <div className="border border-gray-200 rounded-md mb-2 hover:bg-gray-50 cursor-pointer" onClick={handleAgentClick} data-id="element-118">
            <div className="p-3 flex items-center" data-id="element-119">
              <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center mr-3 flex-shrink-0" data-id="element-120">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-121">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-gray-700" data-id="element-122" />
                </svg>
              </div>
              <div data-id="element-123">
                <div className="text-sm font-medium" data-id="element-124">
                  Delegate to AI Custom Agent
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-6" data-id="element-125">
          <div className="flex justify-between items-center mb-2" data-id="element-126">
            <h3 className="text-sm text-gray-500" data-id="element-127">Payment & billing</h3>
          </div>
          <div className="border border-gray-200 rounded-md mb-2 hover:bg-gray-50 cursor-pointer" data-id="element-128">
            <div className="p-3 flex items-center" data-id="element-129">
              <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center mr-3 flex-shrink-0" data-id="element-130">
                <Receipt className="w-4 h-4 text-gray-700" data-id="element-131" />
              </div>
              <div data-id="element-132">
                <div className="text-sm font-medium" data-id="element-133">Generate eCom Receipt</div>
              </div>
            </div>
          </div>
          <div className="border border-gray-200 rounded-md mb-2 hover:bg-gray-50 cursor-pointer" data-id="element-134">
            <div className="p-3 flex items-center" data-id="element-135">
              <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center mr-3 flex-shrink-0" data-id="element-136">
                <div className="w-4 h-4 text-gray-700" data-id="element-137" />
              </div>
              <div data-id="element-138">
                <div className="text-sm font-medium" data-id="element-139">
                  Convert invoice to receipt
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-6" data-id="element-140">
          <div className="flex justify-between items-center mb-2" data-id="element-141">
            <h3 className="text-sm text-gray-500" data-id="element-142">Client management</h3>
          </div>
          <div className="border border-gray-200 rounded-md mb-2 hover:bg-gray-50 cursor-pointer" data-id="element-143">
            <div className="p-3 flex items-center" data-id="element-144">
              <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center mr-3 flex-shrink-0" data-id="element-145">
                <Tag className="w-4 h-4 text-gray-700" data-id="element-146" />
              </div>
              <div data-id="element-147">
                <div className="text-sm font-medium" data-id="element-148">
                  Remove label from contact
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Select Instructions Modal */}
      {isSelectInstructionsModalOpen && <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50" data-id="element-149">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md" data-id="element-150">
            <div className="p-4 border-b border-gray-200 flex items-center justify-between" data-id="element-151">
              <h3 className="text-lg font-medium text-gray-800" data-id="element-152">
                Select AI Custom Agent Instructions
              </h3>
              <button onClick={handleCloseSelectInstructions} className="text-gray-500 hover:text-gray-700" data-id="element-153">
                <X className="w-5 h-5" data-id="element-154" />
              </button>
            </div>
            <div className="p-4 max-h-[400px] overflow-y-auto" data-id="element-155">
              <div className="mb-4" data-id="element-156">
                <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-157">
                  Existing Instructions
                </h4>
                <div className="space-y-2" data-id="element-158">
                  {existingInstructions.map(instruction => <div key={instruction.id} className="border border-gray-200 rounded-md p-3 hover:bg-gray-50 cursor-pointer flex items-center" onClick={() => setIsSelectInstructionsModalOpen(false)} data-id="element-159">
                      <div className="w-8 h-8 bg-teal-400 rounded flex items-center justify-center mr-3 flex-shrink-0" data-id="element-160">
                        {instruction.icon}
                      </div>
                      <div data-id="element-161">
                        <div className="text-sm font-medium" data-id="element-162">
                          {instruction.name}
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
              <div className="border-t border-gray-200 pt-4" data-id="element-163">
                <button className="w-full py-3 border border-gray-200 rounded-md text-sm font-medium flex items-center justify-center hover:bg-gray-50" onClick={handleCreateNewInstructions} data-id="element-164">
                  <Plus className="w-4 h-4 mr-2" data-id="element-165" />
                  Create New Instructions
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};